const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const coerceIsoDate = value => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.toISOString();
  }

  if (typeof value === 'object' && value.fullDate) {
    return coerceIsoDate(value.fullDate);
  }

  if (typeof value !== 'string') {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
};

export const safeIsoDate = value => {
  return coerceIsoDate(value);
};

export const parseUtcDate = value => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const computeEligiblePayoutAt = ({ eventDateValue, deliveredAtValue }) => {
  const eventDate = parseUtcDate(eventDateValue);
  const deliveredAt = parseUtcDate(deliveredAtValue);

  if (!eventDate || !deliveredAt) {
    return null;
  }

  const eventHoldUntil = new Date(eventDate.getTime() + 7 * ONE_DAY_MS);
  const deliveryHoldUntil = new Date(deliveredAt.getTime() + 14 * ONE_DAY_MS);
  return new Date(Math.max(eventHoldUntil.getTime(), deliveryHoldUntil.getTime())).toISOString();
};

export const getEventDateForPayout = ({ protectedData = {}, listingPublicData = {} }) => {
  return (
    safeIsoDate(protectedData.eventDateTime) ||
    safeIsoDate(protectedData.eventDate) ||
    safeIsoDate(protectedData.event_date) ||
    safeIsoDate(listingPublicData.event_date_time) ||
    safeIsoDate(listingPublicData.eventDateTime) ||
    safeIsoDate(listingPublicData.eventDate) ||
    safeIsoDate(listingPublicData.event_date) ||
    null
  );
};

export const getEligiblePayoutAtDate = ({ protectedData = {}, listingPublicData = {} }) => {
  const storedEligiblePayoutAt = parseUtcDate(protectedData.eligiblePayoutAt || null);
  const computedEligiblePayoutAt = parseUtcDate(
    computeEligiblePayoutAt({
      eventDateValue: getEventDateForPayout({ protectedData, listingPublicData }),
      deliveredAtValue: protectedData.deliveredAt || protectedData.deliveryAcceptedAt || null,
    })
  );

  if (storedEligiblePayoutAt && computedEligiblePayoutAt) {
    return new Date(Math.max(storedEligiblePayoutAt.getTime(), computedEligiblePayoutAt.getTime()));
  }

  return storedEligiblePayoutAt || computedEligiblePayoutAt || null;
};
